export default __webpack_public_path__ + "static/media/etc09.c17dc3e6.png";